import React from 'react';
import { CommonIconProps } from './Icon';

const QuestionIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.59999 7.49999C9.59999 6.17452 10.6745 5.1 12 5.1C13.3255 5.1 14.4 6.17452 14.4 7.49999C14.4 8.82546 13.3255 9.89999 12 9.89999C11.0059 9.89999 10.2 10.7059 10.2 11.7V13.5C10.2 14.4941 11.0059 15.3 12 15.3C12.9941 15.3 13.8 14.4941 13.8 13.5V13.2253C16.2343 12.4607 18 10.1866 18 7.49999C18 4.18629 15.3137 1.5 12 1.5C8.68629 1.5 6 4.18629 6 7.49999C6 8.49409 6.80589 9.29999 7.8 9.29999C8.7941 9.29999 9.59999 8.49409 9.59999 7.49999ZM14.4 20.1C14.4 18.7745 13.3255 17.7 12 17.7C10.6745 17.7 9.59999 18.7745 9.59999 20.1C9.59999 21.4255 10.6745 22.5 12 22.5C13.3255 22.5 14.4 21.4255 14.4 20.1Z"
      fill={color}
    />
  </>
);

export default QuestionIcon;
